module.exports = __webpack_public_path__ + "assets/img/icon_arrow_refresh.a4701744.png";